import React from "react";
import RpmBillingAmountInput from "./RpmBillingAmountInput";

const RpmBillingAmountInputForm = (props) => {
  const { formikProps, title, titleStyle } = props;
  const { values } = formikProps;

  return (
    <form style={{ minWidth: "500px" }}>
      <div className="dialog-header__title" style={titleStyle}>
        {title}
      </div>
      {values?.rpmBilling?.map((rpmBillingItem, rpmBillingItemIndex) => (
        <RpmBillingAmountInput
          key={rpmBillingItemIndex}
          index={rpmBillingItemIndex}
          formikProps={formikProps}
          rpmBillingItem={rpmBillingItem}
        />
      ))}
    </form>
  );
};

export default RpmBillingAmountInputForm;
